module.exports = __webpack_public_path__ + "static/media/dragon-one.fd3fd75b.png";